// import {Injectable} from '@angular/core';
// import {AngularFireDatabase} from '@angular/fire/database';
// import {AngularFireAuth} from '@angular/fire/auth';
// import * as firebase from 'firebase/app'; 
// import {BehaviorSubject} from 'rxjs';
// import {ActivatedRoute, Router} from '@angular/router';
// import { backOff, IBackOffOptions } from "exponential-backoff";
// //import {Store} from '@ngrx/store';
// //import {NewConsultationRemainder, NewNotification, NewQuestionNotification} from './models/notification';
// //import {AddNotification, ConsultationRemainderAdd, QuestionNotificationAdd} from './actions/notification';
// //import * as fromRoot from './reducers';
// //import {CurrentPatientService} from './current-patient.service';

// @Injectable()
// export class MessageService {
//   messages: string[] = [];
//   token1: any;
  

//   add(message: string) {
//     this.messages.push(message);
//   }

//   clear() {
//     this.messages = [];
//   }
//   checksupport(){
//     var t = firebase.messaging.isSupported() ? 1 : 0;
//     return t;
//   }
//   messaging =  null;
//   //messaging = firebase.messaging();
//   currentMessage = new BehaviorSubject(null);
//   constructor(private db: AngularFireDatabase, private route: ActivatedRoute, private router: Router, private afAuth: AngularFireAuth) {
//   }
//   printtoken(){
//     return this.token1;
//   }
//   updateToken(token, fdb) {
//     let ftoken = {};
//     ftoken[token] = token;
//     //alert("updateToken");
//     // console.log("in firetoken");
//     // console.log(ftoken);
//     this.token1=token;
//     //alert(token);
//    // const lostruser = JSON.parse(localStorage.getItem('currentUser'));
//     fdb.object('/fcmtokens/').update(ftoken).catch().then(res => {
//       // console.log('sent token to database');
//       //console.log(res);
//       localStorage.setItem('trddpmdoctorfcmtoken', JSON.stringify(ftoken));
//     }).catch((err) => {
//       console.log('Unable to set token in DB.', err); 
//     });
//   }

//   getPermission() {
    
//     console.log('in request permission');
//     if (this.db && ( localStorage.getItem('trddpmdoctorfcmtoken') == null)) {
//       console.log('not null and dont have token');
//       this.generateAndSendTokenToServer(this.db);
//     } else {
//       //alert("already have token");
//       //alert(localStorage.getItem('trddpmdoctorfcmtoken'));
//       console.log('not starting permission already have token');
//     }}
//     //var backing=backOff.options()

//   backOff1<T>(request: () => Promise<T>, options?: Partial<IBackOffOptions>): Promise<T> {
//       const retryDefaults: Partial<IBackOffOptions> = {
//         numOfAttempts:50
//       };
//       return backOff(request, Object.assign(retryDefaults, options || {}));
//     }
//   generateAndSendTokenToServer(fdb) {
//     //alert("generateAndSendTokenToServer");
//     // console.log("getting permission");
//     this.messaging.requestPermission()
//       .then(() => {
//         console.log('Notification permission granted.');
//         //const back=backOff((numOfAttempts:100));
//         const response = this.backOff1(() => this.messaging.getToken());
//         // console.log("here is your token" ,this.backOff1(() => this.messaging.getToken()));
        
//         return response;
//         //return this.messaging.getToken();
//       })
//       .then(token => {
//         //alert("then");
//         this.updateToken(token, fdb);
//         //let ftoken = {};
//         //ftoken[token] = token;
//         //localStorage.setItem('trddpmdoctorfcmtoken', JSON.stringify(ftoken));
//       })
//       .catch((err) => {
//        // alert("err");
//         console.log('Unable to get permission to notify.', err);
//       });
//   }

//   receiveMessage() {
//     //alert("receiveMessage");
//     this.messaging.onMessage((payload) => {
//       console.log("new message received. ", payload);
//       const NotificationOptions = {
//               body: payload.notification.body,
//               data: payload.data,
//               icon: payload.notification.icon
//             }
//             // navigator.serviceWorker.getRegistration('/firebase-messaging-sw.js').then(registration => {
//             //   console.log('Notified' , registration);
//             //   registration.showNotification(payload.notification.title, NotificationOptions);
//             // });
//       this.currentMessage.next(payload);
//   })
// }

//   // receiveMessage() {
//   //   const lostruser = JSON.parse(localStorage.getItem('currentUser'));
//   //   this.messaging.onMessage((payload) => {
//   //     console.log('Message received. ', payload);
//   //     console.log(payload['data']);
//   //     if (payload['data']['app'] === 'dpmd') {
//   //       switch (payload['data']['type']) {
//   //         case '_consultation':
//   //           this.pushPatient.changetok(payload['data']);
//   //           if (payload['data']['doctor_id'] === lostruser['userinfo'][0]['doctor_id_c']) {
//   //             if (payload['data']['consult_type'] === 'video') {
//   //               console.log('video consult call');
//   //               const token = payload['data']['token'];
//   //               const booking_id = payload['data']['booking_id'];
//   //               const session_id = payload['data']['session'];
//   //               const patient_name = payload['data']['pat_name'];
//   //               this.router.navigate(['/recepient']);
//   //             } else if (payload['data']['consult_type'] === 'tele') {
//   //               console.log('tele consult call coming');
//   //               this.router.navigate(['/recepient']);
//   //             }
//   //           }
//   //           this.currentMessage.next(payload['data']);
//   //           break;
//   //         case '_booking':
//   //           alert('booking notification coming...');
//   //           if (payload['data']['doctor_id_c'] === lostruser['userinfo'][0]['doctor_id_c']) {
//   //             // tslint:disable-next-line:max-line-length
//   //             this.store.dispatch(new AddNotification([new NewNotification(payload['data']['doctor_id_c'], payload['data']['booking_type'], payload['data']['booking_id'], payload['data']['pat_img'], payload['data']['appoinment_date'], payload['data']['start_time'])]));
//   //           }
//   //           this.currentMessage.next(payload['data']);
//   //           break;
//   //         case '_todayconsultreminder':
//   //           if (payload['data']['doctor_id_c'] === lostruser['userinfo'][0]['doctor_id_c']) {
//   //             // tslint:disable-next-line:max-line-length
//   //             this.store.dispatch(new ConsultationRemainderAdd([new NewConsultationRemainder(payload['data']['doctor_id_c'], payload['data']['booking_type'], payload['data']['booking_id'], payload['data']['pat_img'])]));
//   //           }
//   //           this.currentMessage.next(payload['data']);
//   //           break;
//   //         case '_questions':
//   //           if (payload['data']['doctor_id_c'] === lostruser['userinfo'][0]['doctor_id_c']) {
//   //             // tslint:disable-next-line:max-line-length
//   //             this.store.dispatch(new QuestionNotificationAdd([new NewQuestionNotification(payload['data']['doctor_id_c'], payload['data'][' pat_image'], payload['data']['pat_name'], payload['data']['patient_id_c'], payload['data']['q_id'])]));
//   //           }
//   //           this.currentMessage.next(payload['data']);
//   //           break;
//   //         default:
//   //           console.log('in default same');
//   //       }
//   //     }
//   //   });
//   // }
// }


import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { BehaviorSubject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
// import * as firebase from 'firebase/app'; // ❌ REMOVE if you're not using it
// import { backOff, IBackOffOptions } from "exponential-backoff"; // ❌ Unused now

@Injectable()
export class MessageService {
  messages: string[] = [];
  token1: any;

  currentMessage = new BehaviorSubject(null);

  constructor(
    private db: AngularFireDatabase,
    private route: ActivatedRoute,
    private router: Router,
    private afAuth: AngularFireAuth
  ) {}

  add(message: string) {
    this.messages.push(message);
  }

  clear() {
    this.messages = [];
  }

  printtoken() {
    return this.token1;
  }

  // 🔇 Stubbed methods to prevent app crash if messaging is referenced
  checksupport(): number {
    return 0;
  }

  getPermission() {
    console.log('Firebase messaging is disabled.');
  }

  generateAndSendTokenToServer(fdb: any) {
    console.log('Firebase messaging is disabled.');
  }

  updateToken(token: any, fdb: any) {
    console.log('Firebase messaging is disabled.');
  }

  receiveMessage() {
    console.log('Firebase messaging is disabled.');
  }
}
